import SmallContainer from '@components/ui/layout/SmallContainer'
import React, { FC } from 'react'
import * as styles from './styles'

export const SectionBottomLine: FC = () => {
  return <SmallContainer as="span" className={styles.bottomLine} />
}
